const PING_EVENT_CODE_LINK_URL = `${process.env.REACT_APP_PING_ORIGIN_URL}/ping-admin/event-code-link`

const PingEventCodeLinkApiUrls = {
    GET: `${PING_EVENT_CODE_LINK_URL}/get`,
    POST: `${PING_EVENT_CODE_LINK_URL}/create`,
    PUT: `${PING_EVENT_CODE_LINK_URL}/update`,
    DELETE: `${PING_EVENT_CODE_LINK_URL}/delete`
}

export default PingEventCodeLinkApiUrls
